import React, { useCallback, useEffect, useState } from 'react';
import { FileDown, CheckCircle2, Loader2 } from 'lucide-react';
import { api } from '../../context/AuthContext';

export const HandakteLeiste = ({ caseId }) => {
  const [st, setSt] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = useCallback(() => api.get(`/kanzlei/akten/${caseId}/handakte`).then((r) => setSt(r.data)).catch(() => setSt(false)), [caseId]);
  useEffect(() => { load(); }, [load]);
  if (!st) return null;
  const pdf = async () => {
    setBusy(true);
    try {
      const r = await api.get(`/kanzlei/akten/${caseId}/handakte.pdf`, { responseType: 'blob' });
      const name = (r.headers['content-disposition'] || '').match(/filename="([^"]+)"/)?.[1] || `Handakte_${caseId}.pdf`;
      const url = URL.createObjectURL(new Blob([r.data], { type: 'application/pdf' }));
      const a = document.createElement('a'); a.href = url; a.download = name; document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(url);
      load();
    } finally { setBusy(false); }
  };
  const ablegen = async () => { await api.post(`/kanzlei/akten/${caseId}/handakte/abgelegt`); load(); };
  const letzter = st.exporte?.[0];
  return (
    <div className="flex flex-wrap items-center gap-2 text-xs" data-testid="handakte-leiste">
      <button type="button" onClick={pdf} disabled={busy} className="inline-flex items-center gap-1.5 h-8 px-3 rounded-[10px] border border-[#1B3A5C] text-[#1B3A5C] hover:bg-[#1B3A5C] hover:text-white transition-colors disabled:opacity-50" data-testid="handakte-pdf">
        {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <FileDown className="w-3.5 h-3.5" />} Handakte-PDF (DATEV)
      </button>
      {st.abgelegt ? <span className="inline-flex items-center gap-1 text-emerald-700" data-testid="handakte-abgelegt"><CheckCircle2 className="w-3.5 h-3.5" /> In DATEV abgelegt · {new Date(st.abgelegt.am).toLocaleDateString('de-DE')} · {st.abgelegt.von}</span>
        : letzter && <button type="button" onClick={ablegen} className="h-8 px-3 rounded-[10px] bg-emerald-600 text-white" data-testid="handakte-ablegen">Als „in DATEV abgelegt“ markieren</button>}
      {letzter && <span className="text-gray-500">Letzter Export {new Date(letzter.am).toLocaleString('de-DE', { dateStyle: 'short', timeStyle: 'short' })} · {letzter.von}</span>}
    </div>
  );
};
